<template>
  <v-row justify="center">
    <v-col cols="auto" class="grey--text text-h4 ">
      O prazo de inscrição está encerrado.
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "prazo-encerrado"
};
</script>
